
import { motion } from "framer-motion";
import React from "react";

interface ProcessCardProps {
  icon: React.ReactNode;
  title: string;
  content: string;
}

const ProcessCard = ({
  icon,
  title,
  content
}: ProcessCardProps) => (
  <motion.div 
    whileHover={{ scale: 1.02 }} 
    className="bg-white p-6 rounded-lg shadow-md border border-[#D3DCE4] transition-all duration-300 hover:shadow-lg hover:border-corporate-secondary-50"
  >
    <div className="mb-4 text-corporate-primary-100 bg-corporate-primary-25 p-3 rounded-lg inline-block">
      {icon}
    </div>
    <h3 className="text-lg font-semibold text-corporate-primary-100 mb-3">{title}</h3>
    <p className="text-corporate-neutral-75 leading-relaxed text-base">{content}</p>
  </motion.div>
);

export default ProcessCard;
